import { EyeIcon } from '@heroicons/react/24/solid'
import { Input, Textarea, Toggle } from '@/components/ui'
import DetailTemplate from '@/components/DetailTemplate'

import { useBienContext } from '../BienContext'
import EditButtons from '../EditButtons'
import Form from './Form'

export default () => {
  const { bien, updatedSections, markSectionAsUpdated, 
    isPendingAction, closeModalCallback
  } = useBienContext()

  const SECTION_ID = 'monopropriete'
  const SECTION_TITLE = "Monopropriété"

  const modalContent = <Form title={SECTION_TITLE} />
  
  const InputDisplayFile = ({item, label, name, title}) => {

    const file = item ? item[name] : null

    const handleClick = (e) => {
      e.preventDefault()
      e.stopPropagation()
      window.open(file.url , '_blank')
    }

    return (
      <div className="flex items-center justify-between">
        <Input.Display label={label} 
          className="flex items-center mb-2 w-full max-w-9/10"
          labelClassName="" 
          valueClassName="overflow-hidden max-w-4/5 text-nowrap"
        >
          { file?.filename ?
              file?.url ? 
                <button title={`Voir ${title}`} className="flex cursor-pointer" onClick={handleClick}>
                  <span>{file.filename}</span>
                </button> :
                <span>{file.filename}</span> :
                null
          }
        </Input.Display>
        <div className="flex mb-2 ml-2 mr-4">
          { !!file?.url && (
            <button 
              onClick={handleClick}
              className="btn btn-xs btn-ghost btn-square p-1 hover:bg-primary-400"
              title={`Voir ${title}`} aria-label={`Voir ${title}`}
            >
              <EyeIcon/>
            </button>
          )}
        </div>
      </div>
    )
  }

  const editButton = <EditButtons
    bienId={bien.id}
    isArchived={!!bien.archived_at}
    isPendingAction={isPendingAction}
    title="Modifier la section Monopropriété"
  /> 

  return(
    <DetailTemplate
      title={SECTION_TITLE}
      sectionId={SECTION_ID}
      bodyProps={{columns: 1}}
      updatedSections={updatedSections}
      loading={false}
      isPendingAction={isPendingAction}
      editButton={editButton}
      modalContent={modalContent}
      onUpdateSuccess={markSectionAsUpdated}
      onCloseModalCallback={closeModalCallback}
    >
      <div className="space-y-4">
        <Input.Display label="Nombre de lots" value={bien.monopropriete_nombre_de_lots} valueClassName="uppercase" />
        <Textarea.Display 
          label="Détails des lots (loyers + charges + DPE)"
          value={bien.monopropriete_details_lots}
          className='flex flex-col items-start'
        />
        <Textarea.Display 
          label="Info Locataires (Impayés ? GLI ? Entente ? Procédure ?)"
          value={bien.monopropriete_info_locataires}
          className='flex flex-col items-start'
        />
      </div>
      <div className='flex space-x-4'>
        <Toggle.Display label="Entretien espaces verts réguliers" 
          value={bien.monopropriete_entretien_espaces_verts} />
        <Toggle.Display label="Entretien communs réguliers" 
          value={bien.monopropriete_entretien_communs} />
        <InputDisplayFile label="Règlement commun" title="le règlement commun" 
          item={bien} name="reglement_commun_file"
        />
      </div>

    </DetailTemplate>
  )
}